/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{cursor:pointer}.icon[_ngcontent-%COMP%]{font-size:35px;line-height:30px}.small[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:25px;line-height:15px}\n/*# sourceMappingURL=authentication-icon.component.css.map*/"];
export { styles as styles };
